import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch (e) {
      setUser(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data);
    return data;
  };
  const adminLogin = async (email, password, pin) => {
    const { data } = await api.post("/auth/admin-login", { email, password, pin });
    setUser(data);
    return data;
  };
  const requestCode = async (email) => {
    const { data } = await api.post("/auth/request-code", { email });
    return data;
  };
  const verifyCode = async (email, code) => {
    const { data } = await api.post("/auth/verify-code", { email, code });
    setUser(data);
    return data;
  };
  const adminLogout = async () => {
    await api.post("/auth/admin-logout");
    await refresh();
  };
  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    setUser(data);
    return data;
  };
  const logout = async () => {
    await api.post("/auth/admin-logout").catch(() => {});
    await api.post("/auth/logout");
    setUser(false);
  };

  return <AuthCtx.Provider value={{ user, login, adminLogin, adminLogout, requestCode, verifyCode, register, logout, refresh }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
export const isStaff = (u) => u && ["admin", "support", "finance"].includes(u.role);
export const hasAdminSession = (u) => isStaff(u) && u.admin_session;
export const hasPerm = (u, perm) => u && (u.role === "admin" || (u.permissions || []).includes(perm));
